<template>
    <div>
        <common-training-header :in-header="true" :withUser="false" />

        <a-card type="inner" size="small" style="margin-top: 24px;">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.members" rowKey="hash" :pagination="false" :loading="loading" bordered>
                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="name" title="Nama" className="align-center  text-left">
                        <template slot-scope="record">
                            <h4>
                                <a-icon type="user" /> {{ record.name }} <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h4>
                        </template>
                    </a-table-column>

                    <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                        <template slot-scope="record">
                            {{ gender(record.gender) }}
                        </template>
                    </a-table-column>

                    <a-table-column :width="100" key="status" title="Status" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <a-tag :color="record.is_active == true ? 'green' : 'red'">
                                {{ record.is_active == true ? "active" : "not active" }}
                            </a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column :width="80" key="action" title="Action" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <a-tooltip title="Lihat Evaluasi">
                                <a-button size="small" icon="eye" :href="routeUri('admin.classical.admin.evaluation.show') + '?attendant=' + record.hash" />
                            </a-tooltip>
                        </template>
                    </a-table-column>

                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: {},
            loading: false,
            processing: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;

            this.$http
                .get(this.routeUri("api.training-members") + "?is_attendant=1")
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
    }
}
</script>
